export class FormPost {
    /**
     * Send a request to the specified URL from a form.
     *
     * This will change the window location.
     *
     * @param {string} uri The URI to send the post request to
     * @param {object} params The parameters to add to the URL
     * @param {string} [method=post] The method to use on the form
     * @see https://stackoverflow.com/a/133997/1552674
     */
    public static post(uri: string, params: any, method = 'post') {
        console.debug(`[JobCenter] Send POST request to ${uri}`);
        const form = document.createElement('form');
        form.method = method;
        form.action = uri;

        for (const key in params) {
            if (params.hasOwnProperty(key)) {
                const hiddenField = document.createElement('input');
                hiddenField.type = 'hidden';
                hiddenField.name = key;
                hiddenField.value = params[key];

                form.appendChild(hiddenField);
            }
        }

        document.body.appendChild(form);
        form.submit();
    }
}
